import { DownloadIcon, RefreshCwIcon, RotateCcwIcon } from "lucide-react";
import { useDesktopAppUpdate } from "src/components/root/DesktopAppUpdateProvider";
import { Button } from "src/components/ui/button";

export const VersionBadge = () => {
  const update = useDesktopAppUpdate();
  if (!update.enabled) return null;

  if (update.phase === "readyToRelaunch") {
    return (
      <Button size="sm" variant="outline" className="w-full" onClick={() => void update.relaunch()}>
        <RotateCcwIcon className="mr-1 h-3.5 w-3.5" /> Relaunch to finish v{update.availableVersion}
      </Button>
    );
  }

  if (update.phase === "available") {
    return (
      <Button size="sm" variant="outline" className="w-full" onClick={() => void update.installUpdate()}>
        <DownloadIcon className="mr-1 h-3.5 w-3.5" /> Update to v{update.availableVersion}
      </Button>
    );
  }

  if (update.phase === "downloading") {
    return (
      <Button size="sm" variant="outline" className="w-full" disabled>
        <RefreshCwIcon className="mr-1 h-3.5 w-3.5 animate-spin" /> Installing
        {update.progress === undefined ? "…" : ` ${update.progress}%`}
      </Button>
    );
  }

  const checking = update.phase === "checking";
  return (
    <Button
      size="sm"
      variant="outline"
      className="w-full"
      disabled={checking}
      title={update.error}
      onClick={() => void update.checkForUpdate()}
    >
      <RefreshCwIcon className={`mr-1 h-3.5 w-3.5 ${checking ? "animate-spin" : ""}`} />
      {checking
        ? "Checking for updates…"
        : update.phase === "error"
          ? "Update check failed — retry"
          : `Version ${update.currentVersion ?? "…"}`}
    </Button>
  );
};
